module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hq274"))).then(() => parcelRequire('1iHdE'));